/**
 * Category dropdown search (Defect B fix, 2026-07-21, ruled design: tiers
 * rank, never restrict). Extracted out of LineItemsEditor.jsx so it's
 * testable without driving the actual Select/dropdown component, and so
 * Item 4's tiered dropdown ("Suggested" / "Used in this RFP" / "All
 * categories") has a stable, already-tested base to build on - that item
 * will add type-affinity RANKING within the Suggested tier only; this
 * function stays the unrestricted full-list search underneath it.
 */
export const searchCategories = (categories, query) => {
  if (!query) return categories || [];
  const q = query.toLowerCase();
  return (categories || []).filter((cat) =>
    cat.custom_code?.toLowerCase().includes(q) ||
    cat.category_name?.toLowerCase().includes(q) ||
    cat.l1_category?.toLowerCase().includes(q) ||
    cat.l2_subcategory?.toLowerCase().includes(q)
  );
};
